import React, { Fragment } from "react";
import Header from "../../components/header/Header";
import About from "../../components/about/about";
import ServiceSection from "../../components/data-solutions-components/ServiceSection/ServiceSection.js";
import CtaSection from "../../components/CtaSection/CtaSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import AwardSection from "../AboutUsPage/AwardSection";
import ProjectSection from "../../components/It-Services-Components/ProjectSection/ProjectSection.js";
import NepalHero from "../../components/hero/NepalHero.js";

const NepalHomePage = () => {
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <main className="page_content">
          <NepalHero/>
          <AwardSection />
          <ServiceSection />
          <About />

          {/* <ProjectSection /> */}

          {/* <ServiceSection />
                    <ProjectSection />
                    <WorkProcess />
                    <IndustrieSection />
                    <Testimonial />*/}
          {/* <FeaturesSection /> */}
          {/* <TeamSection />
                  <FaqSection /> */}

          <CtaSection />
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};
export default NepalHomePage;
